import { jsx as _jsx } from "react/jsx-runtime";
import ChevronUpIcon from '@heroicons/react/outline/ChevronUpIcon';
import ThumbUpIcon from '@heroicons/react/solid/ThumbUpIcon';
import clsx from 'clsx';
import { ReactionType, } from '@tribeplatform/gql-client/types';
import { IconEmoji } from '../common/components/IconEmoji';
export const Reaction = ({ reaction, reactionType, onClick, }) => {
    switch (reactionType) {
        case ReactionType.LIKE_BASE:
            return (_jsx("button", { type: "button", className: clsx('rounded-full flex items-center justify-center -me-2 p-1', reaction.reacted
                    ? 'bg-action-primary hover:primary-focused'
                    : 'bg-surface-pressed hover:bg-skeleton'), onClick: () => {
                    onClick === null || onClick === void 0 ? void 0 : onClick(reaction);
                }, children: _jsx(ThumbUpIcon, { className: clsx('w-3 h-3', { 'text-white': reaction.reacted }) }, void 0) }, void 0));
        case ReactionType.VOTE_BASE:
            return (_jsx("button", { type: "button", className: clsx('rounded-full flex items-center justify-center -me-2 p-1', reaction.reacted
                    ? 'bg-action-primary hover:primary-focused'
                    : 'bg-surface-pressed hover:bg-skeleton'), onClick: () => {
                    onClick === null || onClick === void 0 ? void 0 : onClick(reaction);
                }, children: _jsx(ChevronUpIcon, { className: clsx('w-3 h-3', { 'text-white': reaction.reacted }) }, void 0) }, void 0));
        case ReactionType.EMOJI_BASE:
        default:
            return (_jsx("button", { type: "button", className: clsx('rounded-full w-9 h-7 text-lg border-2 border-line-subdued -me-2 flex items-center justify-center overflow-hidden', 'bg-surface-pressed hover:bg-skeleton'), onClick: () => {
                    onClick === null || onClick === void 0 ? void 0 : onClick(reaction);
                }, children: _jsx(IconEmoji, { text: reaction.reaction }, void 0) }, void 0));
    }
};
//# sourceMappingURL=Reaction.js.map